/*
  This is the summary
 */

import React, {useState} from 'react'
import { useDispatch, useSelector} from "react-redux";
import SaveButtons from '../../SaveButtons'
import {setQuantity} from "../../../store/details/projectDetailsSlice";
import Notice from "../../Notice";
import QuickshipDisplay from "../../common_elements/QuickshipDisplay";

const PatternSummary = (props) => {

    const summary = useSelector(state =>  state.summaryReducer)
    const quantity = useSelector(state =>  state.projectDetailsReducer.quantity)
    const currency = useSelector(state =>  state.projectDetailsReducer.currency)
    const projectType = useSelector(state =>  state.projectDetailsReducer.projectType)
    const priceBook = useSelector(state => state.projectDetailsReducer.priceBook);
    const dispatch = useDispatch();
    const [fieldValue, setFieldValue] = useState("");

    const handleFormChange = (event) => {
        if( event.target.value != fieldValue) {
            setFieldValue(event.target.value)
        }
        getTotal();
    }

    const handleFocus = () => {
        setFieldValue( quantity);
    }

    const getPatternCatalogNumber = () => {
        if(summary == null ){
            return;
        }

        return summary.catalog_number;
    }

    const displayPatternLegs = () => {
        if(summary == null ){
            return;
        }

        if(summary.leg_catalog_numbers == null) {
            return
        }


        let legs = [];
        Object.keys(summary.leg_catalog_numbers).map(function (key) {
            if (key != "CORNER")
               legs.push(
                    <div key={key} style={{"marginTop": '0px'}}>
                       SIDE {key} ({summary.leg_catalog_numbers[key]['quantity']}  per):  <span>{summary.leg_catalog_numbers[key]['catalog_number']}</span>
                       <br/>
                    </div>

               );
            else
                legs.push(
                    <div key={key}  style={{"marginTop": '0px'}}>
                        {key} ({summary.leg_catalog_numbers[key]['quantity']}  per):  <span>{summary.leg_catalog_numbers[key]['catalog_number']}</span>
                        <br/>
                   </div>

                );
            /*
            <div>
                                <span style={styles.span}>{elementIndex}.</span>
                                <span style={styles.catSpan}>{element.element_cat}</span>
                                <span style={styles.span}>- {element.catalog_number}</span>
                            </div>
             */
        });
        legs.push();
        return (legs);
    }

    const getProjectType = () => {
        if(projectType == null ){
            return;
        }

        return projectType
    }

    const getPrice = () => {
        if(summary == null ){
            return;
        }
        return `${currency} ${summary.price}`
    }

    const getPriceBook = () => {
        if(summary == null ){
            return;
        }
        return `${priceBook}`
    }

    const getQuantity = () => {
        if(quantity == null ){
            return;
        }
        return <input min="1" max="99999" style={{width: '6em'}} defaultValue={quantity} type="number" onChange={(e) => handleFormChange(e)} onFocus={() => handleFocus()} onBlur={() => dispatch(setQuantity(fieldValue))}/>
    }

    // this method takes a price in format $2,564.00
    // transforms it into a float 2654.00 multiples by quantity and then transforms back to $x,xxx.00
    // It is also done by API just to verify, but we want to be snappy, so this is much faster for the user
    const getTotal = () =>{

        if(summary == null || quantity == 0 || summary.price == null){
            return `${currency} 0`;
        }
        // need to get rid of $ and , to calculate
        let price = summary.price.replace(",","").replace("$","");
        let total = price * quantity;
        // put $ and , back on
        let formatted_total = `${currency} ${(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
        return formatted_total;
    }


    return (
        <div className="row">
            <div className="small-12 columns no-padding">
                <div className="summary pattern-summary">
                    <div className="panel">
                        <div className="summary-title less-margin">
                            <h2>Summary - { getProjectType() } </h2>
                        </div>
                        <div className="row">
                            <Notice addPadding={true}/>
                            <div className="small-12 columns">
                                <p>Pattern Catalog Number:
                                    <span style={{'marginLeft': '0.2em'}}>
                                        { getPatternCatalogNumber()}
                                    </span>
                                </p>
                                <div className="p no-border-top add-yellow">
                                Catalog Number for Sides:
                                    <div>
                                        {displayPatternLegs()}
                                    </div>
                                </div>

                                <p className="no-border less-padding top-padding">
                                    <div className='row'>
                                        <div className="small-6 columns no-padding">
                                            Unit Price:
                                            <span style={{'marginLeft': '0.2em'}}>
                                                {getPrice()}
                                            </span>
                                        </div>
                                        <div className="small-6 columns no-padding">Price Book:
                                            <span style={{'marginLeft': '0.2em'}}>
                                                {getPriceBook()}
                                            </span>
                                        </div>
                                    </div>
                                </p>

                                <p className="no-border less-padding">
                                    <label> Quantity: </label>
                                    {getQuantity()}
                                </p>
                                <p className="no-border less-padding">Total:
                                    <span style={{'marginLeft': '0.2em'}}>
                                        {getTotal()}
                                    </span>
                                </p>
                                <div style={{marginTop: '10px'}}>
                                    <QuickshipDisplay />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <SaveButtons />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PatternSummary;
